/**
 * useNumberingBaseFieldSlug — slug pola daty numeracji WYBRANEGO typu dokumentu
 * (znormalizowany), do zapalenia gwiazdki „wymagane" w formularzu dokumentu.
 *
 * Silnik renderowania (`useKartotekaRenderField`) zapala gwiazdkę przy polu, którego
 * slug === `numberingBaseFieldSlug` runtime'u. Tę wartość zna typ dokumentu
 * (`numberingBaseField`), więc rozwiązujemy ją z listy typów klasy po `documentTypeId`
 * wybranego typu. `undefined` = brak wybranego typu / typ nieznany → zero gwiazdek
 * numeracyjnych (bezpieczny default, np. dla kartotek read-only jak Produkty).
 *
 * Lista typów jest współdzielona (ten sam klucz cache co picker typu), więc hook nie
 * generuje dodatkowego zapytania. W trybie edycji dokumentu, którego typ nie jest już
 * wybieralny, `find` zwróci undefined (gwiazdka nie zapali się) — numer jest wtedy i tak
 * zamrożony, a serwer nadal broni wymogu przy tworzeniu.
 */

import { useMemo } from 'react';
import { type DocumentClass, normalizeNumberingBaseSlug } from '@saas/shared';

import { useDocumentTypes } from '@/lib/use-document-types';

export function useNumberingBaseFieldSlug(
  documentClass: DocumentClass,
  documentTypeId: string | null,
  companyId?: string | null,
): string | undefined {
  const { data: types } = useDocumentTypes(documentClass, { companyId });
  return useMemo(() => {
    if (!documentTypeId) return undefined;
    const type = types.find((t) => t.id === documentTypeId);
    if (!type) return undefined;
    return normalizeNumberingBaseSlug(documentClass, type.numberingBaseField);
  }, [types, documentTypeId, documentClass]);
}
